// Dynamically import all SVG icons from the main directory only (not subdirectories)
const iconModules = import.meta.glob("./*.svg", {
  query: "?react",
  eager: true,
});

// Mapping function to convert file paths to expected icon names
function createIconsMap() {
  const iconsMap = {};

  // Filename to key mappings for special cases
  const filenameToKeyMap = {
    // Special naming cases
    "Add.svg": "Plus",
    "arrow-right.svg": "Arrow",
    "arrow.svg": "SortArrow",
    "bell.svg": "Bell",
    "chevron.svg": "Chevron",
    "delete.svg": "Delete",
    "Layout-compare.svg": "Compare",
    "Layout-columns.svg": "Kanban",
    "Open-position.svg": "Signpost",
    "Check-small.svg": "Check",
    "Check.svg": "CheckLarge",
    "Time-back.svg": "Restart",
    "User-add.svg": "AddUser",
    "Thumb-Up.svg": "Thumb",
    "competencyCluster.svg": "CompCluster",
    "Openess.svg": "Openess", // Note: keeping the misspelling as in original
    "FullscreenPurple.svg": "FullscreenPurple",
    "FullscreenMinimizePurple.svg": "FullscreenMinimizePurple",
    "ChevronPurple.svg": "ChevronPurple",
    "SendEmpty.svg": "SendEmtpy", // Note: keeping the typo as in original
    "360Assesments.svg": "360Assesment",
    "jpg-3191211.svg": "JPG",
    "pptx-3191194.svg": "PPTX",
    "doc-3191212.svg": "DOC",
    "DragIcon.svg": "Drag",
  };

  // Process main directory icons
  Object.entries(iconModules).forEach(([path, module]) => {
    const filename = path.split("/").pop();

    // Skip the map file itself and non-SVG files
    if (filename === "icons.map.jsx" || !filename.endsWith(".svg")) {
      return;
    }

    let key;
    if (filenameToKeyMap[filename]) {
      key = filenameToKeyMap[filename];
    } else {
      // Convert filename to expected key (remove .svg and handle PascalCase)
      key = filename.replace(".svg", "");
    }

    iconsMap[key] = module.default;
  });

  // Note: Subdirectory icons are not included in the original mapping

  return iconsMap;
}

// Create and export the dynamic IconsMap
/** @type {import('./types').IconsMapType} */
export const IconsMap = createIconsMap();
